<template>
  <div>
    <!--分类管理  -->
    <baseBreadcrumb :page="$t('message.classifyManage')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <!-- 商品主分类 -->
        <el-tab-pane :label="$t('message.CommodityClassification')" name="1">
        </el-tab-pane>
        <!-- 默认推荐 -->
        <el-tab-pane :label="$t('message.defaultRecommendation')" name="2">
        </el-tab-pane>
        <!-- 普通商品推荐 -->
        <el-tab-pane :label="$t('message.GeneralProductrecommendation')" name="3">
        </el-tab-pane>
      </el-tabs>
      <!-- 商品主分类 -->
      <commodityClassification v-if="activeName == 1" />
      <!-- 默认推荐 -->
      <DefaultPersonalizedRecommendation v-if="activeName == 2" />
      <!-- 普通商品推荐 -->
      <GeneralProductrecommendation v-if="activeName == 3" />
    </div>
  </div>
</template>
<script>
import commodityClassification from "./components/commodityClassification";
import DefaultPersonalizedRecommendation from "./components/DefaultPersonalizedRecommendation";
import GeneralProductrecommendation from "./components/GeneralProductrecommendation";

export default {
  components: {
    commodityClassification,
    DefaultPersonalizedRecommendation,
    GeneralProductrecommendation,
  },
  data() {
    return {
      activeName: "1",
    };
  },
  methods: {
    handleClick() { },
  },
};
</script>
<style lang='scss' scoped>
.body {
  position: relative;
}
</style>